export default "__VITE_ASSET__Chl08Nw0__"